export * from './translations';
export * from './translate.pipe';
export * from './translate.service';



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/i18n/index.ts